import TemplateView from "../../../TemplateView";
import ScopeCell, {SCOPE_CELL_STATUS} from "./ScopeCell";
import TeamCellDetailsBlock from "./TeamCellDetailsBlock";

export default class TeamScopeCell extends TemplateView {

    constructor({
        onClickCb = () => {},
    }) {
        super()

        this.params = {
            onClickCb,
        }

        this.state = {
            highlighted: false,
            disabled: false,
            readOnly: false,
            status: SCOPE_CELL_STATUS.ALL,
            assignedUsersCount: 0,
        }

        this.onAnyStatePropertyChanged(['highlighted', 'disabled', 'status', 'readOnly'], () => {
            this.scopeCell.setState({
                highlighted : this.state.highlighted,
                disabled: this.state.disabled || this.state.readOnly,
                status: this.state.status
            })
        })

        this.onAnyStatePropertyChanged(['status', 'assignedUsersCount'], () => {
            this.teamDetailsBlock.setState({
                status: this.state.status,
                assignedUsersCount: this.state.assignedUsersCount
            })
        })
    }

    templateHtml() {
        return "<div class='teamScopeCellContainer'></div>"
    }

    afterRender() {
        this.teamDetailsBlock = new TeamCellDetailsBlock()

        this.scopeCell = new ScopeCell({
            onClickCb: this.params.onClickCb,
            detailsBlock: this.teamDetailsBlock,
            notAllowedTextKey: 'user.scope_cell.no_access',
            notSelectedTextKey: 'user.scope_cell.users.not_selected',
            noAccessTextKey: 'user.scope_cell.users.no_access',
        }).init(this.$el)

        this.scopeCell.setState({
            allSelectedTextKey: 'user.scope_cell.users.all_selected'
        })

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/TeamScopeCell.js